import { createSelector } from "reselect";
import { fuzzSearch } from "@utils/search-helpers";
import {
  searchAndReplaceByObjKey,
  searchAndRemoveByKeyVal,
} from "@utils/array-helpers";
import { convertISODateTime } from "@utils/time-helpers";
import moment from "moment-timezone";

const dataTable = (state) => state.dataSet;
const filters = (state) => state.filter;

export const inDateBounds = (individualItem, filterObj) => {
  let { startDateTime, stopDateTime } = filterObj;
  let startDateMatch =
    !startDateTime ||
    (individualItem.inputISOStartDate &&
      individualItem.inputISOStartDate >= startDateTime);
  let selectedStopDateFilterPlusADay;
  if (stopDateTime) {
    selectedStopDateFilterPlusADay = moment(stopDateTime)
      .add(1, "day")
      .toDate();
  }
  let stopDateMatch =
    !stopDateTime ||
    (individualItem.inputISOStopDate &&
      individualItem.inputISOStopDate <= selectedStopDateFilterPlusADay);
  return startDateMatch && stopDateMatch;
};

export const composedSelector = createSelector(
  dataTable,
  filters,
  (dataTable, filters) =>
    dataTable?.filter((tableItems) => applyAllFilters(tableItems, filters))
);

export const applyAllFilters = (...args) => {
  return (
    selectFilters(...args) && searchFilter(...args) && inDateBounds(...args)
  );
};

export const selectFilters = (individualItem, filterObj) => {
  let matchAll = true;
  let filterSet = filterObj.filterSelect; //(({searchValue, queryKeys, idKey, startDateTime, stopDateTime, ...otherKeys}) => ({...otherKeys}))(filterObj)
  for (let i in filterSet) {
    matchAll = !filterSet[i] || individualItem[i] === filterSet[i];
    if (!matchAll) {
      return matchAll;
    }
  }
  return matchAll;
};

export const searchFilter = (individualItem, filterObj) => {
  let { searchValue, queryKeys, idKey } = filterObj;
  try {
    let copiedList = {
      ...individualItem,
      [idKey]: individualItem[idKey].toString(),
    };
    let matchingIdStrings = fuzzSearch(searchValue, [copiedList], queryKeys);
    return matchingIdStrings.length > 0;
  } catch (err) {
    console.warn(err);
    return;
  }
};

export const updateViewList = (keyLookUp, id, viewList, newVal) => {
  return !newVal
    ? searchAndRemoveByKeyVal(keyLookUp, id, viewList)
    : searchAndReplaceByObjKey(keyLookUp, id, viewList, newVal);
};

export const timeEnrichment = (item, action, stripTime = false) => ({
  ...(action === "view"
    ? {
        inputISOStartDate: convertISODateTime(item.start_date)
          .toMomentWithDBTimeZone,
        inputISOStopDate: convertISODateTime(item.stop_date)
          .toMomentWithDBTimeZone,
      }
    : action === "send"
    ? {
        start_date: item.inputISOStartDate
          ? stripTime
            ? convertISODateTime(item.inputISOStartDate).toDBDateString
            : convertISODateTime(item.inputISOStartDate).toDBDateTimeString
          : null,
        stop_date: item.inputISOStopDate
          ? stripTime
            ? convertISODateTime(item.inputISOStopDate).toDBDateString
            : convertISODateTime(item.inputISOStopDate).toDBDateTimeString
          : null,
      }
    : {}),
});
